import Layout from '../../../internal/Layout.vue'
import electricalSafetyPatternManage from './index.vue'

const electricalSafetyPatternManageRoutes = {
  component: Layout,
  children: [
    {
      name: 'electricalSafetyPatternManage',
      path: '/electricalSafety/patternManage',
      component: electricalSafetyPatternManage,
      meta: {
        module: 'calibracao',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: false,
        requiresCoordSector: false,
        requiresLaboratory: true,
      },
    },
  ],
}

export default electricalSafetyPatternManageRoutes
